import { Files, PaperPlaneTilt } from "@phosphor-icons/react";

export const LEAD_FACET_KEYS = [
  "lead_of",
  "origins",
  "current_companies",
  "past_companies",
  "locations",
  "labels",
  "schools",
  "skills",
  "interests",
  "languages",
] as const;

export const OUTREACH_CRM_EXPORT_OPTIONS = {
  campaign: {
    icon: PaperPlaneTilt,
  },
  list: {
    icon: Files,
  },
};

export const LEADS_TAB_ITEMS = [
  { label: "Leads", path: "", end: true },
  { label: "Labels", path: "labels" },
];
